module.exports = __webpack_public_path__ + "46f53e51cad07ac01166e37ddf5225ef.svg";